module.exports = __webpack_public_path__ + "assets/6b1b3c45340e349fab2f1dc89b203bcf.png";